import {Routes, RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes,  { useHash: true })
    ],
    /*providers: [
     AuthGuard,
     LoginGuard
     ],*/
    exports: [
        RouterModule
    ]
})
export class AppRoutes {}




// WEBPACK FOOTER //
// ./src/app/app.routes.ts